type CallbackType = (
  el: IntersectionObserverEntry,
  unobserve: (el: Element) => void
) => void;

type Constructor<T> = new (...args: any[]) => T;

export default class VisibilityManager {
  static #instance: VisibilityManager | null = null;
  #observer: IntersectionObserver;
  #callbackMap: Map<Element, CallbackType> = new Map();

  private constructor(observer: Constructor<IntersectionObserver>) {
    this.#observer = new observer(this.handleIntersection);
    this.unobserve = this.unobserve.bind(this);
    this.observe = this.observe.bind(this);
    this.disconnect = this.disconnect.bind(this);
  }

  private handleIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      this.#callbackMap.get(entry.target)?.(entry, this.unobserve);
    });
  };

  observe(element: Element | null, callback: CallbackType) {
    if (!element) {
      return;
    }
    this.#callbackMap.set(element, callback);
    this.#observer.observe(element);
  }

  unobserve(element: Element | null) {
    if (!element) {
      return;
    }
    this.#callbackMap.delete(element);
    this.#observer.unobserve(element);
  }

  disconnect() {
    this.#observer.disconnect();
  }

  public static getInstance(
    observer: Constructor<IntersectionObserver> = IntersectionObserver
  ): VisibilityManager {
    if (!VisibilityManager.#instance) {
      VisibilityManager.#instance = new VisibilityManager(observer);
    }

    return VisibilityManager.#instance;
  }
}
